import React, { FC } from 'react';

import { Button } from 'devextreme-react/button';

import styles from './AppModalFooter.module.css';

type ModalFooterProps = {
  hideModal: () => void;
  handleSubmit: (e: any) => void;
  textClose?: string;
  textConfirm?: string;
  typeConfirm?: 'danger' | 'default' | 'normal' | 'success' | undefined;
  useSubmitBehavior?: boolean;
  disabledSubmit?: boolean;
  hideConfirm?: boolean;
};

const ModalFooter: FC<ModalFooterProps> = (props) => {
  return (
    <div className={styles.footer}>
      <Button
        width={120}
        text={props.textClose || 'Отмена'}
        type="normal"
        onClick={props.hideModal}
        stylingMode="text"
      />
      {!props.hideConfirm && (
        <Button
          text={props.textConfirm}
          type={props.typeConfirm}
          stylingMode="text"
          useSubmitBehavior={props.useSubmitBehavior}
          onClick={props.handleSubmit}
          disabled={props.disabledSubmit}
        />
      )}
    </div>
  );
};

ModalFooter.defaultProps = {
  useSubmitBehavior: true,
  typeConfirm: 'success',
  textConfirm: 'Сохранить',
};

export default ModalFooter;
